import { Dropdown } from "Components/Shared/Inputs/Form/Dropdown";
import { LicensePaymentStatus } from "Infrastructure/Api/Api";
import type { CodeListItem } from "Models/ICodeListDto";
import { useMemo } from "react";
import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { Resources, useResource } from "Translations/Resources";
import { typedObjectEntries } from "Utils/ObjectUtils";

type PaymentStatusDropdownProps<
  FormType extends FieldValues,
  TransformedFieldValues extends FieldValues = FormType,
> = {
  name: FieldPath<FormType>;
  control: Control<FormType, unknown, TransformedFieldValues>;
  label?: string;
};

type ListItem = CodeListItem<LicensePaymentStatus>;

export const PaymentStatusDropdown = <
  FormType extends FieldValues,
  V extends FieldValues = FormType,
>({
  control,
  name,
  label,
}: PaymentStatusDropdownProps<FormType, V>) => {
  const { t } = useResource();

  const options = useMemo<ListItem[]>(
    () =>
      typedObjectEntries(LicensePaymentStatus).map<ListItem>(
        ([key, value]) => ({
          code: value,
          name: t(
            Resources.Pages.Content.UserDetailPageContent.Tabs.Licenses.Form
              .Fields.PaymentStatus.options[key],
          ),
        }),
      ),
    [t],
  );

  return (
    <Dropdown codeList={options} name={name} control={control} label={label} />
  );
};
